import { useState } from "react";

// Which auto-release preview orders are checked. Orders with unsaved line
// edits ("dirty") can't be selected until saved.
const useAutoReleaseSelection = ({ previewData, setPreviewData }) => {
  const [selectedOrdnames, setSelectedOrdnames] = useState([]);
  const [dirtyOrders, setDirtyOrders] = useState(new Set());

  const handleDirtyChange = (ordname, isDirty) => {
    setDirtyOrders((prev) => {
      const next = new Set(prev);
      isDirty ? next.add(ordname) : next.delete(ordname);
      return next;
    });
    if (isDirty) setSelectedOrdnames((prev) => prev.filter((o) => o !== ordname));
  };

  const toggleOrder = (ordname, isChecked) =>
    setSelectedOrdnames((prev) => (isChecked ? [...prev, ordname] : prev.filter((o) => o !== ordname)));

  const close = () => {
    setPreviewData(null);
    setSelectedOrdnames([]);
    setDirtyOrders(new Set());
  };

  const releasableOrdnames = (previewData?.toRelease || [])
    .filter((r) => !dirtyOrders.has(r.ordname))
    .map((r) => r.ordname);

  const selectedOrders = (previewData?.toRelease || []).filter((r) => selectedOrdnames.includes(r.ordname));

  return {
    selectedOrdnames,
    setSelectedOrdnames,
    hasDirty: dirtyOrders.size > 0,
    handleDirtyChange,
    toggleOrder,
    close,
    releasableOrdnames,
    selectedOrders,
  };
};

export default useAutoReleaseSelection;
